'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$rootScope', '$scope', '$uibModalInstance', '$uibModalStack', 'SupportToolService', 'ProjectSupportService', 'support', 'edit', 'project',
                function($rootScope, $scope, $modalInstance, $uibModalStack, SupportToolService, ProjectSupportService, support, edit, project) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.onClickSupport = onClickSupport;
                    $scope.onCloseSupport = onCloseSupport;
                    $scope.edit = edit;

                    init(); 

                    // region Function

                    function init() {
                        $scope.projectSupport = angular.copy(support);
                        $scope.dateFormat = 'dd.MM.yyyy';

                        SupportToolService.api.get({
                                                       filters: [`'status' EQ 'ENABLED'`],
                                                       sorts: ['name:ASC'],
                                                   }, (data) => $scope.supportTools = data._embedded);
                    }

                    $scope.btns = {
                        create: {
                            show: () => $scope.edit,
                            click: () => {
                                // Эти параметры в rootScope используются при открытии модалки выбора меры поддержки
                                $rootScope.onClickSupport = onClickSupport
                                $rootScope.closeSupportTool = onCloseSupport
                                $rootScope.activeProject = angular.copy(project);
                                ProjectSupportService.selectSupTool({}, $scope.edit).result.then(function (data) {
                                    if (!$scope.items.some(item => equals(item, data))) {
                                        console.log(data)
                                        // $scope.items.push(data);
                                    }
                                });
                            },
                            disabled: () => false,
                        }
                    }

                    function onClickSupport(item) {
                        $scope.projectSupport.supportTool = item

                        const top = $uibModalStack.getTop();
                        if (top) {
                            $uibModalStack.dismiss(top.key);
                        }
                    };

                    function onCloseSupport() {
                        const top = $uibModalStack.getTop();
                        if (top) {
                            $uibModalStack.dismiss(top.key);
                        }
                        if ($rootScope.onClickSupport) delete $rootScope.onClickSupport;
                        if ($rootScope.cancel) delete $rootScope.cancel
                        if ($rootScope.activeProject) delete $rootScope.activeProject;
                    }

                    function ok() {
                        $modalInstance.close($scope.projectSupport);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    // endregion
                }];
